import * as React from "react";
import { connect } from "react-redux";

import { QuestionnaireConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { PhysiotherapyForm } from "@teamprevent/common/physiotherapy/components/PhysiotherapyForm";
import { PhysiotherapyMgrReferral } from "@teamprevent/common/physiotherapy/components/PhysiotherapyMgrReferral";
import { loadOrgStructure } from "@teamprevent/common/questionnaires/components/physiotherapyReferralForm/actions";

import { ApplicationState } from "../../applicationState";
import { loadPhysiotherapyMgrReferralConfig } from "../../questionnaireConfig/actions";
import { selectAndMergePhysiotherapyMgrReferralQuestionnaireConfig } from "../selectors";

import { push } from "redux-little-router";

interface StateProps {
    ohCaseId: string;
    questionnaireConfig: QuestionnaireConfig;
}

interface DispatchProps {
    loadQuestionnaireConfig: () => void;
    afterSubmit: (ohCaseId: string) => void;
    loadOrgStructure: (parentOrgStructureLevelId: string) => void;
}

type Props = StateProps & DispatchProps;

class WritablePhysiotherapyFormUnconnected extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    public componentDidMount() {
        this.props.loadQuestionnaireConfig();
    }

    public render() {
        return (
            <PhysiotherapyForm
                readonly={false}
                questionnaireConfig={this.props.questionnaireConfig}
                afterSubmit={this.props.afterSubmit}
                physiotherapyReferralFormComponent={PhysiotherapyMgrReferral}
                loadOrgStructure={this.props.loadOrgStructure}
                documentBaseApi={"/api/physiotherapy"}
            />
        );
    }
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    ohCaseId: state.router.params.ohCaseId,
    questionnaireConfig: selectAndMergePhysiotherapyMgrReferralQuestionnaireConfig(state)
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
    loadQuestionnaireConfig: () => dispatch(loadPhysiotherapyMgrReferralConfig()),
    afterSubmit: () => dispatch(push("/")),
    loadOrgStructure: (parentOrgStructureLevelId: string) => dispatch(loadOrgStructure(parentOrgStructureLevelId))
});

export const WritablePhysiotherapyForm = connect(mapStateToProps, mapDispatchToProps)(WritablePhysiotherapyFormUnconnected);
